export default __webpack_public_path__ + "static/media/return.78446aeb.png";